module.exports = __webpack_public_path__ + "91ad8e83ca3bd1eb82de5e81a957807c.svg";